import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const normTarga = (t) => (t || "").replace(/[^A-Za-z0-9]/g, "").toUpperCase();

export async function lookupPreview(targa) {
  const { data } = await api.get(`/vehicles/${normTarga(targa)}/preview`);
  return data;
}

export async function getReport(targa) {
  const { data } = await api.get(`/report/${normTarga(targa)}`);
  return data;
}

export const couponStore = {
  get() {
    try {
      return JSON.parse(localStorage.getItem("veritarga_coupon")) || null;
    } catch {
      return null;
    }
  },
  set(c) {
    localStorage.setItem("veritarga_coupon", JSON.stringify(c));
  },
  clear() {
    localStorage.removeItem("veritarga_coupon");
  },
};

(function captureCouponFromUrl() {
  try {
    const c = (new URLSearchParams(window.location.search).get("coupon") || "").trim().slice(0, 40);
    if (c) {
      couponStore.set(c);
      window.history.replaceState({}, "", window.location.pathname + window.location.hash);
    }
  } catch {}
})();

export async function createCheckout(targa, couponCode = couponStore.get()) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key: "veritarga_report_one_time",
    origin_url: window.location.origin,
    targa: normTarga(targa),
    coupon_code: couponCode || "",
  });
  return data;
}

export async function pollPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export const saveLastSession = (sid, targa) =>
  localStorage.setItem("veritarga_last_session", JSON.stringify({ sid, targa }));

export const readLastSession = () => {
  try {
    return JSON.parse(localStorage.getItem("veritarga_last_session"));
  } catch {
    return null;
  }
};

export const rememberedPlates = {
  add(t) {
    const list = rememberedPlates.list();
    if (!list.includes(t)) localStorage.setItem("veritarga_unlocked", JSON.stringify([...list, t]));
  },
  list() {
    try {
      return JSON.parse(localStorage.getItem("veritarga_unlocked")) || [];
    } catch {
      return [];
    }
  },
};
